export const NAV_ITEMS = ["Colores", "Usos", "Características", "Dónde comprar"]

export const GLOBAL_SITE_TAG = "GTM-55ZPCW4"
